import { TFunction } from 'i18next';
import { FieldItem } from '@lib/interfaces/form';
import FieldTitleRender from '@lib/components/FieldTitleRender/FieldTitleRender';
import DocumentFormFieldNames from '@lib/enums/fieldNames/documentFormFieldNames';
import { EdmDocumentRenewalReminderTemplateFragmentFragment } from 'graphql-common';
import getRenewalReminderFields from './getRenewalReminderFields';

export default function getLifecycleFields({
  t,
  template,
  hasPriorReminderValues,
  isFullAdmin = true,
  isPlanLocked,
  isBlockStart = true,
}: {
  t: TFunction<'translation', undefined>;
  template?: EdmDocumentRenewalReminderTemplateFragmentFragment | null;
  hasPriorReminderValues?: boolean;
  isFullAdmin?: boolean;
  isPlanLocked?: boolean;
  isBlockStart?: boolean;
}): FieldItem[] {
  // The whole renewal-reminder block is a Full-Admin-only upgrade
  // affordance when the plan is locked.
  if (isPlanLocked && !isFullAdmin) return [];
  return [
    {
      name: DocumentFormFieldNames.LifecycleTitle,
      customRender: () => (
        <FieldTitleRender
          key="lifecycle"
          title={t('lifecycle')}
          isBlockStart={isBlockStart}
        />
      ),
    },
    ...getRenewalReminderFields({
      t,
      template,
      hasPriorReminderValues,
      isPlanLocked,
    }),
  ];
}
